module.exports = __webpack_public_path__ + "static/img/年度最佳智能眼镜.7dcf2b50.png";